import Storage from './storage';

export function setSessionStorage(session) {
  try {
    const { merchant, user, auth } = session;
    Storage.setLocalStorage('merchant', merchant);
    Storage.setLocalStorage('user', user);
    Storage.setLocalStorage('auth', auth);
    return true;
  } catch (err) {
    return err;
  }
}

export function getSessionStorage() {
  try {
    return {
      merchant: Storage.getLocalStorage('merchant'),
      user: Storage.getLocalStorage('user'),
      auth: Storage.getLocalStorage('auth'),
    };
  } catch (err) {
    return err;
  }
}

export function clearSessionStorage() {
  try {
    Storage.removeLocalStorage('merchant');
    Storage.removeLocalStorage('user');
    Storage.removeLocalStorage('auth');
    return true;
  } catch (err) {
    return err;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/session.js